import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getAdmissionConfig } from "../lib/api";
import { SITE, whatsappLink } from "../lib/site";

export function WhatsAppIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
      <path d="M16.003 3C8.832 3 3 8.83 3 16c0 2.29.6 4.53 1.74 6.5L3 29l6.68-1.72A12.94 12.94 0 0 0 16.003 29C23.17 29 29 23.17 29 16S23.17 3 16.003 3Zm0 23.63c-2.02 0-4-.54-5.72-1.57l-.41-.24-3.96 1.02 1.06-3.86-.27-.4A10.6 10.6 0 0 1 5.37 16c0-5.86 4.77-10.63 10.64-10.63 5.86 0 10.62 4.77 10.62 10.63 0 5.86-4.77 10.63-10.63 10.63Zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.66 0 1.57 1.14 3.08 1.3 3.3.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.89-.77 2.15-1.52.27-.74.27-1.38.19-1.52-.08-.13-.29-.21-.61-.37Z" />
    </svg>
  );
}

/** Floating "chat on WhatsApp" button shown on public pages. */
export default function WhatsAppButton() {
  const { pathname } = useLocation();
  const [number, setNumber] = useState(SITE.whatsapp);

  useEffect(() => {
    getAdmissionConfig()
      .then((c) => c?.whatsapp_number && setNumber(c.whatsapp_number))
      .catch(() => {});
  }, []);

  const message =
    pathname.toLowerCase().includes("admission") || pathname.toLowerCase().includes("fee")
      ? "Assalam o Alaikum, I would like information about admissions at The International School."
      : "Assalam o Alaikum, I would like to know more about The International School.";

  return (
    <a
      href={whatsappLink(message, number)}
      target="_blank"
      rel="noreferrer"
      className="group fixed bottom-5 right-5 z-[60] flex items-center gap-2 rounded-full bg-[#25D366] p-3.5 text-white shadow-lift transition hover:bg-[#1ebe5a] sm:bottom-6 sm:right-6"
      aria-label="Chat with TIS admissions on WhatsApp"
    >
      <WhatsAppIcon className="h-7 w-7" />
      <span className="hidden pr-1 text-sm font-bold sm:group-hover:inline">Chat with admissions</span>
    </a>
  );
}
